import { CommentsField } from "@/shared/components/CommentsField";
import { ErrorModal, MesfModal } from "@dexteel/mesf-core";
import { Button, Grid2 } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { upsertComments } from "../../repositories/MillOverviewRepository";

type Props = {
	show: boolean;
	onHide: () => void;
	standId: number;
	currentComments: string;
};

export const CommentModal = ({
	show,
	onHide,
	standId,
	currentComments,
}: Props) => {
	const [comments, setComments] = useState(currentComments);
	const [error, setError] = useState("");
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);

	const queryClient = useQueryClient();
	const updateComments = useMutation(upsertComments, {
		onSuccess: async () => {
			await queryClient.invalidateQueries(["millOverviews"]);
			onHide();
			setComments("");
		},
		onError: (error: Error) => {
			setError(error.message);
		},
		onSettled: () => setIsSubmitLoading(false),
	});

	const onSubmit = async () => {
		setIsSubmitLoading(true);
		updateComments.mutate({
			standId: standId,
			comments: comments,
		});
	};

	useEffect(() => {
		setComments(currentComments);
	}, [currentComments, standId]);

	return (
		<>
			<MesfModal handleClose={() => onHide()} open={show}>
				<MesfModal.Content style={{ padding: "20px 30px 0px" }}>
					<Grid2 style={{ marginTop: 10 }}>
						<CommentsField
							value={comments}
							onChange={(comment) => setComments(comment)}
							rows={{ minRows: 5, maxRows: 5 }}
						/>
					</Grid2>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "0px 30px 20px" }}>
					<Grid2
						container
						size={{ md: 12 }}
						spacing={1}
						justifyContent="flex-end"
					>
						<Grid2 size={{ md: 6, xs: 12 }}>
							<Button
								fullWidth
								variant="contained"
								color="inherit"
								onClick={() => onHide()}
							>
								Cancel
							</Button>
						</Grid2>
						<Grid2 size={{ md: 6, xs: 12 }}>
							<Button
								fullWidth
								disabled={comments == "" || isSubmitLoading}
								variant="contained"
								color="primary"
								onClick={() => onSubmit()}
							>
								Save
							</Button>
						</Grid2>
					</Grid2>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
